import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ListLayout } from '@components';
import { useAsyncInit, useNavOptionsSet } from '@hooks';
import { ToastService } from '@services';
import { parseApiError } from '@utils';
import { LatestTracksList } from './components/LatestTracksList';
import { useTracksModel } from '@models/Tracks/TracksModel';

export const LatestTracksScreen = observer(() => {
  const { t } = useTranslation();
  const track = useTracksModel();

  useNavOptionsSet({ title: t('latestTracks.title') });

  useAsyncInit(async () => {
    try {
      await track.latest.fetch.run();
    } catch (error) {
      ToastService.showError(parseApiError(error).message);
    }
  });

  async function refresh() {
    try {
      await track.latest.fetch.run();
    } catch (error) {
      ToastService.showError(parseApiError(error).message);
    }
  }

  async function fetchMore() {
    try {
      await track.latest.fetchMore.run();
    } catch (error) {
      ToastService.showError(parseApiError(error).message);
    }
  }

  return (
    <ListLayout title={t('latestTracks.title')}>
      <LatestTracksList
        list={track.latest}
        refresh={refresh}
        fetchMore={fetchMore}
      />
    </ListLayout>
  );
});
